import { ORG_OWNER, ORG_ADMIN, ALL_ROLES, ORG_SUPER_ADMIN } from "./Roles";

export const canChangeOrgOwner = (orgInfo, user) => {
  return isOrgOwner(orgInfo, user);
};

export const canDeleteOrg = (orgInfo, user) => {
  return isOrgOwner(orgInfo, user);
};

export const canChangeOrgName = (orgInfo, user) => {
  return canManageOrg(orgInfo, user);
};

export const isAlreadyActiveMemberOfOrg = (user, orgInfo) => {
  let filteredMember = orgInfo.members.filter((member) => {
    let emailID = member.emailId;
    return (
      emailID.trim() === user?.emailId.trim() && member.status === "ACCEPTED"
    );
  });
  return filteredMember.length > 0;
};

export const getOrgOwner = (orgInfo) => {
  if (!orgInfo?.members || orgInfo?.members.length < 1) {
    return { emailId: orgInfo?.ownerEmailId };
  }
  let filteredMember = orgInfo?.members.filter((member) => {
    return member.roleId === ORG_OWNER.roleId;
  });
  //TODO Remove the below condition.
  return filteredMember[0]
    ? filteredMember[0]
    : { emailId: orgInfo.ownerEmailId };
};

export const canManageOrg = (orgInfo, user) => {
  let canManage = false;
  if (!orgInfo?.members || orgInfo?.members?.length < 1) {
    canManage = false;
  }
  orgInfo?.members?.forEach((member) => {
    if (
      member?.emailId === user?.emailId &&
      (member.roleId === ORG_OWNER.roleId ||
        member.roleId === ORG_ADMIN.roleId ||
        member.roleId === ORG_SUPER_ADMIN.roleId)
    ) {
      canManage = true;
    }
  });
  return canManage || isOrgOwner(orgInfo, user);
};

export const canInvite = (orgInfo, user) => {
  let canInvite = false;
  if (!orgInfo?.members || orgInfo?.members?.length < 1) {
    canInvite = false;
  }
  orgInfo?.members?.forEach((member) => {
    if (
      member?.emailId === user?.emailId &&
      (member.roleId === ORG_OWNER.roleId ||
        member.roleId === ORG_SUPER_ADMIN.roleId)
    ) {
      canInvite = true;
    }
  });
  return canInvite || isOrgOwner(orgInfo, user);
};

export const isOrgOwner = (orgInfo, user) => {
  const owner = getOrgOwner(orgInfo);
  return (
    owner?.emailId?.trim() === (user?.emailId || user?.memberEmailId)?.trim()
  );
};

export const siteBelongsToOrg = (siteId, orgsSiteDetails, userOrgs) => {
  const res = orgsSiteDetails?.filter((orgSiteDetails) => {
    let filteredSiteDetails = orgSiteDetails?.siteDetailsResponses?.filter(
      (site) => site.siteId === siteId,
    );
    return filteredSiteDetails?.length > 0 ? orgSiteDetails : false;
  });
  return res?.length > 0 ? filterOrgDetails(res[0].orgId, userOrgs) : null;
};

export const filterOrgDetails = (orgId, userOrgs) => {
  const res = userOrgs.filter((org) => orgId === org.orgId);
  return res.length > 0 ? res[0] : null;
};

// export const getRoleInOrg = (userEmail, org) => {
//   let user = org?.members?.filter((member) => member.emailId === userEmail);
//   if (user && user.length > 0) {
//     return getDisplayName(user[0].roleId);
//   }
// };

export const getRoleInOrg = (userEmail, org) => {
  let user = org?.members?.find((member) => member.emailId === userEmail);
  if (user) {
    return getDisplayName(user.roleId);
  }
};

export const getDisplayName = (roleId) => {
  let roleDetails = ALL_ROLES.filter((role) => role.roleId === roleId);
  return roleDetails[0].displayName;
};

export const isSuperAdmin = (roleId) => {
  let roleDetails = ALL_ROLES.filter((role) => role.roleId === roleId);
  return roleDetails[0].displayName === "Super Admin";
};

export const canCreateOrg = (roleId) => {
  let roleDetails = ALL_ROLES.filter((role) => role.roleId === roleId);
  return (
    roleDetails[0].displayName === "Owner" ||
    roleDetails[0].displayName === "Super Admin"
  );
};
